import React, {useEffect, useRef, useState} from "react";
import {classNames} from "../../../util/util-helpers";

export default function ScrollableColumn({children, className, tabIndex}) {
    const scrollRef = useRef(null);
    const [canScrollUp, setCanScrollUp] = useState(false);
    const [canScrollDown, setCanScrollDown] = useState(true);

    function updateScrollState() {
        const el = scrollRef.current;
        if (!el) return;
        setCanScrollUp(el.scrollTop > 0);
        setCanScrollDown(el.scrollTop + el.clientHeight < el.scrollHeight - 1);
    }

    useEffect(() => {
        updateScrollState();
    }, []);

    return (
        <div className="flex flex-col">
            <button
                type="button"
                onClick={() => scrollRef.current?.scrollBy({top: -32, behavior: 'smooth'})}
                className={classNames(
                    !canScrollUp && "opacity-0 pointer-events-none",
                    "flex items-center justify-center w-full h-5 cursor-pointer text-tm-gray-400 hover:text-primary rounded-sm select-none"
                )}
            >
                <span className="text-xs">▲</span>
            </button>

            <div
                ref={scrollRef}
                className={classNames("overflow-y-auto", className)}
                tabIndex={tabIndex}
                onScroll={updateScrollState}
            >
                {children}
            </div>

            <button
                type="button"
                onClick={() => scrollRef.current?.scrollBy({top: 32, behavior: 'smooth'})}
                className={classNames(
                    !canScrollDown && "opacity-0 pointer-events-none",
                    "flex items-center justify-center w-full h-5 cursor-pointer text-tm-gray-400 hover:text-primary rounded-sm select-none"
                )}
            >
                <span className="text-xs">▼</span>
            </button>
        </div>
    );
}
